import { List, ListItem, Text } from '@shared/components';
import { formatSecondsToHoursMinutes } from '@shared/utils';

export interface TimeLimitInformationProps {
  timeLimits: { order: number; value: number }[];
}

export default function TimeLimitInformation(props: Readonly<TimeLimitInformationProps>) {
  const { timeLimits } = props;

  if (timeLimits.length === 1) {
    return <Text>{formatSecondsToHoursMinutes(timeLimits[0].value, 'TEXT')}</Text>;
  }

  const sortedTimeLimits = [...timeLimits].sort((a, b) => a.order - b.order);

  return (
    <List
      disablePadding
      sx={(theme) => ({ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) })}
    >
      {sortedTimeLimits.map((time) => (
        <ListItem key={time.order} sx={{ p: 0 }}>
          <Text>
            <Text variant='body1Semibold' component='span'>
              ช่วงเวลาที่ {time.order + 1}:
            </Text>{' '}
            {formatSecondsToHoursMinutes(time.value, 'TEXT')}
          </Text>
        </ListItem>
      ))}
    </List>
  );
}
